import { render } from "./ArticleGallerySlider.vue?vue&type=template&id=a8aa5c1a"
import script from "./ArticleGallerySlider.vue?vue&type=script&lang=js"
export * from "./ArticleGallerySlider.vue?vue&type=script&lang=js"

import "./ArticleGallerySlider.vue?vue&type=style&index=0&id=a8aa5c1a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__